export const EditIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.675 3.14344L10.8565 6.32569L3.4315 13.7499H0.25V10.5677L7.675 3.14269V3.14344ZM8.7355 2.08294L10.3263 0.491441C10.4669 0.350837 10.6576 0.271851 10.8565 0.271851C11.0554 0.271851 11.2461 0.350837 11.3868 0.491441L13.5085 2.61319C13.6491 2.75384 13.7281 2.94457 13.7281 3.14344C13.7281 3.34231 13.6491 3.53304 13.5085 3.67369L11.917 5.26444L8.7355 2.08294Z"
                fill="currentColor"
            />
        </svg>
    );
};
